/**
 * SolarNEST dual-tilt: Module to Module Gap (ridge/peak and valley) by module frame width (mm).
 * Spec table 28–40 mm; values for 41–60 and <28 inferred at −2 mm gap per 1 mm frame width.
 */

const RIDGE_MM: number[] = [
  117.2, 115.2, 113.3, 111.3, 109.3, 107.3, 105.3, 103.4, 101.42, 99.44, 97.46, 95.4, 93.49,
]
const VALLEY_MM: number[] = [
  96.11, 94.1, 92.15, 90.19, 88.18, 86.2, 84.2, 82.2, 80.26, 78.28, 76.3, 74.3, 72.3,
]

const FRAME_WIDTH_MIN = 28
const FRAME_WIDTH_MAX_TABLE = 40
const GAP_PER_MM = 2

/** 40 mm row values for extrapolation above 40 */
const RIDGE_AT_40 = 93.49
const VALLEY_AT_40 = 72.3
/** 28 mm row values for extrapolation below 28 */
const RIDGE_AT_28 = 117.2
const VALLEY_AT_28 = 96.11

export interface RidgeValleyMeters {
  ridgeM: number
  valleyM: number
}

/**
 * Returns ridge (peak) and valley spacing in meters for SolarNEST dual-tilt from module frame width (mm).
 * 28–40: table lookup; >40: infer from 40 mm row at −2 mm per mm; <28: infer from 28 mm row at +2 mm per mm.
 */
export function getSolarNestRidgeValleySpacingMeters(frameWidthMm: number): RidgeValleyMeters {
  const w = frameWidthMm
  let ridgeMm: number
  let valleyMm: number

  if (w >= FRAME_WIDTH_MIN && w <= FRAME_WIDTH_MAX_TABLE) {
    const index = Math.round(w) - FRAME_WIDTH_MIN
    const i = Math.max(0, Math.min(index, RIDGE_MM.length - 1))
    ridgeMm = RIDGE_MM[i]
    valleyMm = VALLEY_MM[i]
  } else if (w > FRAME_WIDTH_MAX_TABLE) {
    ridgeMm = RIDGE_AT_40 - GAP_PER_MM * (w - FRAME_WIDTH_MAX_TABLE)
    valleyMm = VALLEY_AT_40 - GAP_PER_MM * (w - FRAME_WIDTH_MAX_TABLE)
  } else {
    ridgeMm = RIDGE_AT_28 + GAP_PER_MM * (FRAME_WIDTH_MIN - w)
    valleyMm = VALLEY_AT_28 + GAP_PER_MM * (FRAME_WIDTH_MIN - w)
  }

  return {
    ridgeM: ridgeMm / 1000,
    valleyM: valleyMm / 1000,
  }
}
